module.exports = {
	"data": {
		"site": {
			"siteMetadata": {
				"title": "KeystoneJS"
			}
		},
		"allMarkdownRemark": {
			"edges": [
				{
					"node": {
						"section": "Getting Started",
						"slug": "/getting-started",
						"headings": [
							{
								"value": "Getting Started"
							}
						]
					}
				},
				{
					"node": {
						"section": "Getting Started",
						"slug": "/getting-started/yo-generator",
						"headings": [
							{
								"value": "Keystone Yeoman Generator"
							},
							{
								"value": "Routes & Views"
							}
						]
					}
				},
				{
					"node": {
						"section": "Getting Started Setting Up",
						"slug": "/getting-started/setting-up/part-1",
						"headings": [
							{
								"value": "Part 1: Initial Setup"
							}
						]
					}
				},
				{
					"node": {
						"section": "Getting Started Setting Up",
						"slug": "/getting-started/setting-up/part-2",
						"headings": [
							{
								"value": "Part 2 - Database Setup"
							}
						]
					}
				},
				{
					"node": {
						"section": "Getting Started Setting Up",
						"slug": "/getting-started/setting-up/part-3",
						"headings": [
							{
								"value": "Part 3: Routing"
							}
						]
					}
				},
				{
					"node": {
						"section": "Getting Started Setting Up",
						"slug": "/getting-started/setting-up/part-4",
						"headings": [
							{
								"value": "Part 4 -  Adding data to the database from a form"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field",
						"headings": [
							{
								"value": "Field types"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/options",
						"headings": [
							{
								"value": "Field Options"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Methods",
						"slug": "/api/methods/close-database-connection",
						"headings": [
							{
								"value": "Close Database connection"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Methods",
						"slug": "/api/methods/create-items",
						"headings": [
							{
								"value": "Create Items"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Methods",
						"slug": "/api/methods/create-router",
						"headings": [
							{
								"value": "Create Router"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Methods",
						"slug": "/api/methods/get",
						"headings": [
							{
								"value": "Get"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Methods",
						"slug": "/api/methods/import",
						"headings": [
							{
								"value": "Import"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Methods",
						"slug": "/api/methods/importer",
						"headings": [
							{
								"value": "Importer"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Methods",
						"slug": "/api/methods",
						"headings": [
							{
								"value": "Methods"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Methods",
						"slug": "/api/methods/init",
						"headings": [
							{
								"value": "Init"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Methods",
						"slug": "/api/methods/list",
						"headings": [
							{
								"value": "list"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Methods",
						"slug": "/api/methods/middleware",
						"headings": [
							{
								"value": "Middleware"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Methods",
						"slug": "/api/methods/open-database-connection",
						"headings": [
							{
								"value": "Open Database Connection"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Methods",
						"slug": "/api/methods/paginate",
						"headings": [
							{
								"value": "Paginate"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Methods",
						"slug": "/api/methods/pre",
						"headings": [
							{
								"value": "Pre"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Methods",
						"slug": "/api/methods/set",
						"headings": [
							{
								"value": "Set"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Methods",
						"slug": "/api/methods/start",
						"headings": [
							{
								"value": "Start"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Methods",
						"slug": "/api/methods/update-handler",
						"headings": [
							{
								"value": "Update Handler"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api View",
						"slug": "/api/view",
						"headings": [
							{
								"value": "View"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api View",
						"slug": "/api/view/on",
						"headings": [
							{
								"value": "on"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api View",
						"slug": "/api/view/query",
						"headings": [
							{
								"value": "query"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api View",
						"slug": "/api/view/render",
						"headings": [
							{
								"value": "render"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api List",
						"slug": "/api/list/add",
						"headings": [
							{
								"value": "Add"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api List",
						"slug": "/api/list",
						"headings": [
							{
								"value": "List"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api List",
						"slug": "/api/list/model",
						"headings": [
							{
								"value": "Model"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api List",
						"slug": "/api/list/options",
						"headings": [
							{
								"value": "List Construction Options"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api List",
						"slug": "/api/list/register",
						"headings": [
							{
								"value": "Register"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api List",
						"slug": "/api/list/schema",
						"headings": [
							{
								"value": "Schema"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api List",
						"slug": "/api/list/update-item",
						"headings": [
							{
								"value": "Update Item"
							}
						]
					}
				},
				{
					"node": {
						"section": "Guides",
						"slug": "/guides/api-file-image-uploads",
						"headings": [
							{
								"value": "API File and Image Uploads"
							}
						]
					}
				},
				{
					"node": {
						"section": "Guides",
						"slug": "/guides/how-to-create-a-blog-with-keystone",
						"headings": [
							{
								"value": "How to create a blog with Keystone"
							}
						]
					}
				},
				{
					"node": {
						"section": "Guides",
						"slug": "/guides/how-to-send-emails",
						"headings": [
							{
								"value": "How to send emails with Keystone"
							}
						]
					}
				},
				{
					"node": {
						"section": "Guides",
						"slug": "/guides",
						"headings": [
							{
								"value": "Guides"
							}
						]
					}
				},
				{
					"node": {
						"section": "Guides",
						"slug": "/guides/v-0-3-to-v-4-0-upgrade-guide",
						"headings": [
							{
								"value": "Upgrade Guide: 0.3 to 4.0"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation",
						"slug": "/documentation/application-updates",
						"headings": [
							{
								"value": "Application Updates"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation",
						"slug": "/documentation",
						"headings": [
							{
								"value": "Documentation"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Configuration",
						"slug": "/documentation/configuration",
						"headings": [
							{
								"value": "Keystone Setup Options"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Database",
						"slug": "/documentation/database",
						"headings": [
							{
								"value": "Database Configuration"
							}
						]
					}
				},
				{
					"node": {
						"section": "Documentation Database",
						"slug": "/documentation/database/relationships",
						"headings": [
							{
								"value": "Relationships"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/azurefile",
						"headings": [
							{
								"value": "AzureFile Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/file",
						"headings": [
							{
								"value": "File Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/embedly",
						"headings": [
							{
								"value": "Embedly Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/localfiles",
						"headings": [
							{
								"value": "Local Files"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/localfile",
						"headings": [
							{
								"value": "LocalFile Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/s-3-file",
						"headings": [
							{
								"value": "S3 File Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/boolean",
						"headings": [
							{
								"value": "Boolean Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/cloudinaryimage",
						"headings": [
							{
								"value": "CloudinaryImage Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/code",
						"headings": [
							{
								"value": "Code Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/cloudinaryimages",
						"headings": [
							{
								"value": "CloudinaryImages Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/color",
						"headings": [
							{
								"value": "Color Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/date",
						"headings": [
							{
								"value": "Date Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/datearray",
						"headings": [
							{
								"value": "Datearray field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/datetime",
						"headings": [
							{
								"value": "DateTime Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/geopoint",
						"headings": [
							{
								"value": "GeoPoint Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/email",
						"headings": [
							{
								"value": "Email Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/key",
						"headings": [
							{
								"value": "Key Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/html",
						"headings": [
							{
								"value": "HTML Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/money",
						"headings": [
							{
								"value": "Money Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/location",
						"headings": [
							{
								"value": "Location Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/markdown",
						"headings": [
							{
								"value": "Markdown Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/name",
						"headings": [
							{
								"value": "Name Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/password",
						"headings": [
							{
								"value": "Password Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/number",
						"headings": [
							{
								"value": "Number Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/numberarray",
						"headings": [
							{
								"value": "NumberArray field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/relationship",
						"headings": [
							{
								"value": "Relationship Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/select",
						"headings": [
							{
								"value": "Select Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/text",
						"headings": [
							{
								"value": "Text Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/textarea",
						"headings": [
							{
								"value": "Textarea Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/textarray",
						"headings": [
							{
								"value": "Textarray Field"
							}
						]
					}
				},
				{
					"node": {
						"section": "Api Field",
						"slug": "/api/field/url",
						"headings": [
							{
								"value": "URL Field"
							}
						]
					}
				}
			]
		},
		"markdownRemark": {
			"parent": {
				"relativePath": "Guides/how-to-send-emails.md"
			},
			"slug": "/guides/how-to-send-emails",
			"headings": [
				{
					"value": "How to send emails with Keystone"
				}
			],
			"html": "<h1 id=\"how-to-send-emails-with-keystone\"><a href=\"#how-to-send-emails-with-keystone\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>How to send emails with Keystone</h1>\n<p>We often had to send emails in our Keystone projects, so we figured we\nmight as well make that easier. With the standalone\n<a href=\"http://npm.im/keystone-email\"><code>keystone-email</code></a> package, containing Mailgun\nand Mandrill integrations, you’ll be sending emails in less than 5\nminutes!</p>\n<h2 id=\"setup\"><a href=\"#setup\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Setup</h2>\n<ol>\n<li>Install the <code>keystone-email package</code> in your project with</li>\n</ol>\n<pre><code class=\"language-sh\">npm install keystone-email --save\n</code></pre>\n<p>That’s everything there is to it from the Keystone side!</p>\n<p>You will need a <a href=\"https://mailgun.com\">Mailgun</a> account to be able to\nsend emails though. (Mailgun gives you 10000 emails/month for free!)\nLet’s create that:</p>\n<ol>\n<li>Sign up on <a href=\"https://mailgun.com\">mailgun.com</a></li>\n<li>When you’ve created the account you should see a message saying\n“You’re signed up and we just created your sandbox server\nxyz.mailgun.org”. <strong>Copy the link to your sandbox to a safe place</strong>,\nwe’ll use it soon!</li>\n<li>Click on “authorized recipients” on that page and invite yourself\nwith your own email as an authorized recipient <div>\n          <a\n            class=\"gatsby-resp-image-link\"\n            title=\"original image\"\n            href=\"/1a791340072f6cb2e19daa3ea728f6a6-quality=50&pngCompressionLevel=9&width=1612.png\"\n            style=\"display: block\"\n            target=\"_blank\"\n          >\n            <div\n              class=\"gatsby-resp-image-wrapper\"\n              style=\"position: relative; z-index: -1; margin-bottom: 1.125rem;\"\n            >\n              <div\n                class=\"gatsby-resp-image-background-image\"\n                style=\"padding-bottom: 62.779156327543426%;position: relative; width: 100%; bottom: 0; left: 0; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAACc0lEQVQ4y32SS08TURTH+2GMiYmBPqClVje40Y2JC8tDkBg7TakuICWpEoyNukE/Qlm5qCSGmJiauMPUINMHhNJpxXbSgjRQ+mCmU1rGSePfey8dQoNyJ7/8Z86553HvHMP68rI5mxOCO9s7QTHzI7gZXwtmk5vB4m4xuLe3x6C+Qr5w+k19Yk7sgu7hv/O3DbFYbKhcLmuMUknbLxY1iWhdUTrUNUWSNEUm1E/e60RlAtVqtarp8YIgzNGEI8QIymGthkJtH1v72/h58AtbpR1kd3PIZRIQE1+RD79DIbuBsnSA8rGCitoASQo9PpVKBQzRaHSkUqmAUiMJj45bkBsKDpU65KMGZEVBVZZQiX9DM7OO32oLf9hzsmRZhh5POnzBOtQNlLdv5vHU78Ps7BRmn00xfe9zY4u7i4XHD+HzTWNmZproFPx+P2uiK+HZDinDw/dgsZjQ12ck9DJe9V/Gl2uX4DRegdHYwzCbe2Cz2XA2tishuVRmHB8fJRv7CVYMdBhzWPD8hhE37f2dYiZYrWY4HA7osZR/dnh/dAzXHXY47HbYB6ywER5Yr+KWpYcVMpl6SVIj0ws71HkZeI1JzyQ8nAecy4VHQ04s3BnEk4lxcBwHl4uD2+1m6vV62d/975GpM50WQGzgozzT+OdPSH38gORago5FF5lMBpIkdR85Ho+fziF1NptNNlutVouhtdu4aCl0rDrxJGHAwPO8s1QqqRRSRc3n86ooimrjqKkqjSZTUkSlq91un4OMjarHJ5PJOcPS0tLgyspKhLK6uhpZXFyMhEKhyMamwEimhAg5GiOdTp+DXEtEjw+HwxN/AWIQMss5+AS2AAAAAElFTkSuQmCC'); background-size: cover;\"\n              >\n                <img\n                  class=\"gatsby-resp-image-image\"\n                  style=\"width: 100%; margin: 0; vertical-align: middle; position: absolute; box-shadow: inset 0px 0px 0px 400px white;\"\n                  alt=\"Mailgun Signup\nPage\"\n                  title=\"\"\n                  src=\"/1a791340072f6cb2e19daa3ea728f6a6-quality=50&pngCompressionLevel=9&width=800.png\"\n                  srcset=\"/1a791340072f6cb2e19daa3ea728f6a6-quality=50&pngCompressionLevel=9&width=200.png 200w,/1a791340072f6cb2e19daa3ea728f6a6-quality=50&pngCompressionLevel=9&width=400.png 400w,/1a791340072f6cb2e19daa3ea728f6a6-quality=50&pngCompressionLevel=9&width=800.png 800w,/1a791340072f6cb2e19daa3ea728f6a6-quality=50&pngCompressionLevel=9&width=1200.png 1200w,/1a791340072f6cb2e19daa3ea728f6a6-quality=50&pngCompressionLevel=9&width=1600.png 1600w,/1a791340072f6cb2e19daa3ea728f6a6-quality=50&pngCompressionLevel=9&width=1612.png 1612w\"\n                  sizes=\"(max-width: 800px) 100vw, 800px\"\n                />\n              </div>\n            </div>\n          </a>\n          </div></li>\n<li>Activate your account and agree to be an authorized recipient in the\ntwo emails Mailgun sent you</li>\n<li>Go to your dashboard, click on your name in the top right corner and\nshow and <strong>copy your private API key</strong> and store it next to the\nsandbox URL, we’ll need that too!</li>\n</ol>\n<p><div>\n          <a\n            class=\"gatsby-resp-image-link\"\n            title=\"original image\"\n            href=\"/cf1fadc24655bafe45bef33dba529e05-quality=50&pngCompressionLevel=9&width=1612.png\"\n            style=\"display: block\"\n            target=\"_blank\"\n          >\n            <div\n              class=\"gatsby-resp-image-wrapper\"\n              style=\"position: relative; z-index: -1; margin-bottom: 1.125rem;\"\n            >\n              <div\n                class=\"gatsby-resp-image-background-image\"\n                style=\"padding-bottom: 62.779156327543426%;position: relative; width: 100%; bottom: 0; left: 0; background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAACYUlEQVQ4y4WTW2sTQRTH98P4XmgoYZMmasAHNQHRovZJP0WfCi2GSCCUaujbCjFQrIFUKUStrRvTrdDmHnMBS41pIgRC7rdmOm1znDN1l4QIDvx2Z/ec/c9/zpkV3nk805+2t6SgHJR2tnc0Ql9DkqIoHPmLLO3u7GrPoVBoLBeRZVnaeLNxW1hZWXkkud301Us39b72Uq93Eo/Ho83X19epz+ejfr+frq6u0nsP5qjVaqU2m42ura0tCvv7+/PFkxMo5PNQKpWgWCxCpVKBarX6TzCGeel0GpzPHeCeuQZ6vR6MRiNEo9FlgV3mT09PYTAYcAghcH5+DpeXl2NcXFxwKKXQ6XTg28EBPL57H+ZmpkCn04HBYIBcLrckhMPhK0EmRP6Cws1mE9rtNrRaLWix+2gM8xMftuCZcRosop47NM2aIJPJLAmRSGS+3+/zpFHK5TL8KhQgz0pRr9fHYij64/1beGGagjtGEURRBLPZfCWIDlFQ3bL6wQmrazKZhEQiAY1GY2LB2OeP8NRiglvXzZOCvV4XULTX62nC2ABsENLtdrX3KsG9PZi9cRNEg5HXELetCaIDpFarcVHVsVo3dITvRslms+B0OsFut4PD4eBzrYZYI/VYYAfR0f9AUXp2xjuvDi6IxwbdnLEgMupIrdeoYzWPn4RGk4viGA6HKLgsHB4ePmSuCNsqh22dsA4TVjtydHREjo9/khKbM/eEHSEtr93ukN/lKmFuCVuUk0qlFoXNzU1LPB5XWEfHYH+QsrCwoLhcLoUlTsRjsbgSSaSVZCqtJJDkdyUQCDz5AwTpVySe4PqZAAAAAElFTkSuQmCC'); background-size: cover;\"\n              >\n                <img\n                  class=\"gatsby-resp-image-image\"\n                  style=\"width: 100%; margin: 0; vertical-align: middle; position: absolute; box-shadow: inset 0px 0px 0px 400px white;\"\n                  alt=\"Mailgun Signup Page\"\n                  title=\"\"\n                  src=\"/cf1fadc24655bafe45bef33dba529e05-quality=50&pngCompressionLevel=9&width=800.png\"\n                  srcset=\"/cf1fadc24655bafe45bef33dba529e05-quality=50&pngCompressionLevel=9&width=200.png 200w,/cf1fadc24655bafe45bef33dba529e05-quality=50&pngCompressionLevel=9&width=400.png 400w,/cf1fadc24655bafe45bef33dba529e05-quality=50&pngCompressionLevel=9&width=800.png 800w,/cf1fadc24655bafe45bef33dba529e05-quality=50&pngCompressionLevel=9&width=1200.png 1200w,/cf1fadc24655bafe45bef33dba529e05-quality=50&pngCompressionLevel=9&width=1600.png 1600w,/cf1fadc24655bafe45bef33dba529e05-quality=50&pngCompressionLevel=9&width=1612.png 1612w\"\n                  sizes=\"(max-width: 800px) 100vw, 800px\"\n                />\n              </div>\n            </div>\n          </a>\n          </div></p>\n<blockquote>\n<p>Note: You can also use Mandrill with <code>keystone-email</code>, but since it\nhas no free tier we’ll skip it for this guide, see the\n<a href=\"http://npm.im/keystone-email\"><code>keystone-email</code></a> docs for more\ninformation!</p>\n</blockquote>\n<p>Now we’re all setup to start sending emails!</p>\n<h2 id=\"sending-your-first-email\"><a href=\"#sending-your-first-email\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Sending your first email</h2>\n<p>For exemplary purposes, create a <code>test-email.js</code> file in the root of\nyour project and require <code>keystone-email</code>:</p>\n<pre><code class=\"language-javascript\"><span class=\"token comment\" spellcheck=\"true\">// test-email.js</span>\n<span class=\"token keyword\">var</span> Email <span class=\"token operator\">=</span> <span class=\"token function\">require</span><span class=\"token punctuation\">(</span><span class=\"token string\">'keystone-email'</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span></code></pre>\n<p><code>keystone-email</code> uses templates. You can use whatever templating engine\nyou prefer (set it via the <code>engine</code> option) but for this guide we’ll be\nusing <code>pug</code>! (formerly called <code>jade</code>)</p>\n<p>Create another file in the root folder called <code>test-email.pug</code> and fill\nit with this content:</p>\n<pre><code class=\"language-jade\"><span class=\"token markup\"><span class=\"token comment\" spellcheck=\"true\">&lt;!-- test-email.pug --></span></span>\n\n<span class=\"token doctype\">doctype html</span>\n<span class=\"token tag\">html<span class=\"token attributes\"><span class=\"token punctuation\">(</span><span class=\"token attr-name\">lang</span><span class=\"token punctuation\">=</span><span class=\"token attr-value\"><span class=\"token string\">\"en\"</span></span><span class=\"token punctuation\">)</span></span></span>\n  <span class=\"token tag\">head</span>\n  <span class=\"token tag\">body</span>\n    <span class=\"token tag\">h1</span> <span class=\"token plain-text\">Your first email sent with Keystone!</span>\n    <span class=\"token tag\">p</span> <span class=\"token plain-text\">Congratulations on sending your first email with Keystone</span></code></pre>\n<p>Nothing fancy, a simple heading and paragraph for now.</p>\n<p>Let’s swap back to our <code>test-email.js</code> file and tell <code>keystone-email</code>\nwhich template we want to use. We pass that in as the first argument to\n<code>new Email()</code>:</p>\n<pre><code class=\"language-javascript\"><span class=\"token comment\" spellcheck=\"true\">// test-email.js</span>\n<span class=\"token keyword\">var</span> Email <span class=\"token operator\">=</span> <span class=\"token function\">require</span><span class=\"token punctuation\">(</span><span class=\"token string\">'keystone-email'</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n\n<span class=\"token keyword\">new</span> <span class=\"token class-name\">Email</span><span class=\"token punctuation\">(</span><span class=\"token string\">'test-email.pug'</span><span class=\"token punctuation\">,</span> <span class=\"token punctuation\">{</span><span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span></code></pre>\n<p>In the second argument, the email options, we tell it we want to use\nMailgun as the email transport mechanism by setting <code>transport</code> to\n<code>mailgun</code> (surprisingly!):</p>\n<pre><code class=\"language-javascript\"><span class=\"token comment\" spellcheck=\"true\">// test-email.js</span>\n<span class=\"token keyword\">var</span> Email <span class=\"token operator\">=</span> <span class=\"token function\">require</span><span class=\"token punctuation\">(</span><span class=\"token string\">'keystone-email'</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n\n<span class=\"token keyword\">new</span> <span class=\"token class-name\">Email</span><span class=\"token punctuation\">(</span><span class=\"token string\">'test-email.pug'</span><span class=\"token punctuation\">,</span> <span class=\"token punctuation\">{</span>\n  transport<span class=\"token punctuation\">:</span> <span class=\"token string\">'mailgun'</span><span class=\"token punctuation\">,</span>\n<span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span></code></pre>\n<p>This won’t actually <code>send</code> the email though! (how should it, we haven’t\ntold Keystone where to send the email to yet!)</p>\n<p>When called, <code>Email</code> returns a <code>send</code> function that you can use to\nactually send an email with the specified template. It takes three\narguments: the <code>locals</code> (the data that goes into the template), the\n<code>senderOptions</code> (where to send the email to/from, the subject, the\nmailgun options,…) and as the last argument a callback.</p>\n<p>Since we don’t have any data in our template yet, we’ll simply set the\n<code>locals</code> to an empty object:</p>\n<pre><code class=\"language-javascript\"><span class=\"token comment\" spellcheck=\"true\">// test-email.js</span>\n<span class=\"token keyword\">var</span> Email <span class=\"token operator\">=</span> <span class=\"token function\">require</span><span class=\"token punctuation\">(</span><span class=\"token string\">'keystone-email'</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n\n<span class=\"token keyword\">new</span> <span class=\"token class-name\">Email</span><span class=\"token punctuation\">(</span><span class=\"token string\">'test-email.pug'</span><span class=\"token punctuation\">,</span> <span class=\"token punctuation\">{</span>\n  transport<span class=\"token punctuation\">:</span> <span class=\"token string\">'mailgun'</span><span class=\"token punctuation\">,</span>\n<span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">.</span><span class=\"token function\">send</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span><span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span></code></pre>\n<p>The <code>senderOptions</code> are the meat of this function call. We need to tell\n<code>keystone-email</code> where to send the email <code>to</code>, where it should pretend\nto come <code>from</code>, what the <code>subject</code> is and finally the Mailgun API\ndetails and sandbox url:</p>\n<pre><code class=\"language-javascript\"><span class=\"token comment\" spellcheck=\"true\">// test-email.js</span>\n<span class=\"token keyword\">var</span> Email <span class=\"token operator\">=</span> <span class=\"token function\">require</span><span class=\"token punctuation\">(</span><span class=\"token string\">'keystone-email'</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n\n<span class=\"token keyword\">new</span> <span class=\"token class-name\">Email</span><span class=\"token punctuation\">(</span><span class=\"token string\">'test-email.pug'</span><span class=\"token punctuation\">,</span> <span class=\"token punctuation\">{</span>\n  transport<span class=\"token punctuation\">:</span> <span class=\"token string\">'mailgun'</span><span class=\"token punctuation\">,</span>\n<span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">.</span><span class=\"token function\">send</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span><span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span> <span class=\"token punctuation\">{</span>\n  apiKey<span class=\"token punctuation\">:</span> <span class=\"token string\">'YOURAPIKEYHERE'</span><span class=\"token punctuation\">,</span>\n  domain<span class=\"token punctuation\">:</span> <span class=\"token string\">'sandox123asdf234YOURSANDBOX.mailgun.com'</span><span class=\"token punctuation\">,</span>\n  to<span class=\"token punctuation\">:</span> <span class=\"token string\">'yourauthorizedrecipient@email.here'</span><span class=\"token punctuation\">,</span>\n  <span class=\"token keyword\">from</span><span class=\"token punctuation\">:</span> <span class=\"token punctuation\">{</span>\n    name<span class=\"token punctuation\">:</span> <span class=\"token string\">'Your Site'</span><span class=\"token punctuation\">,</span>\n    email<span class=\"token punctuation\">:</span> <span class=\"token string\">'hello@yoursite.com'</span><span class=\"token punctuation\">,</span>\n  <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n  subject<span class=\"token punctuation\">:</span> <span class=\"token string\">'Your first KeystoneJS email'</span><span class=\"token punctuation\">,</span>\n<span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span></code></pre>\n<p>If you tried to run this, it would already work! 🎉 Let’s add a callback\nthough, to make sure we get errors logged if something goes wrong or a\nmessage logged if it goes right:</p>\n<pre><code class=\"language-javascript\"><span class=\"token comment\" spellcheck=\"true\">// test-email.js</span>\n<span class=\"token keyword\">var</span> Email <span class=\"token operator\">=</span> <span class=\"token function\">require</span><span class=\"token punctuation\">(</span><span class=\"token string\">'keystone-email'</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n\n<span class=\"token keyword\">new</span> <span class=\"token class-name\">Email</span><span class=\"token punctuation\">(</span><span class=\"token string\">'test-email.pug'</span><span class=\"token punctuation\">,</span> <span class=\"token punctuation\">{</span>\n  transport<span class=\"token punctuation\">:</span> <span class=\"token string\">'mailgun'</span><span class=\"token punctuation\">,</span>\n<span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">.</span><span class=\"token function\">send</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span><span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span> <span class=\"token punctuation\">{</span>\n  apiKey<span class=\"token punctuation\">:</span> <span class=\"token string\">'YOURAPIKEYHERE'</span><span class=\"token punctuation\">,</span>\n  domain<span class=\"token punctuation\">:</span> <span class=\"token string\">'sandox123asdf234YOURSANDBOX.mailgun.com'</span><span class=\"token punctuation\">,</span>\n  to<span class=\"token punctuation\">:</span> <span class=\"token string\">'yourauthorizedrecipient@email.here'</span><span class=\"token punctuation\">,</span>\n  <span class=\"token keyword\">from</span><span class=\"token punctuation\">:</span> <span class=\"token punctuation\">{</span>\n    name<span class=\"token punctuation\">:</span> <span class=\"token string\">'Your Site'</span><span class=\"token punctuation\">,</span>\n    email<span class=\"token punctuation\">:</span> <span class=\"token string\">'hello@yoursite.com'</span><span class=\"token punctuation\">,</span>\n  <span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span>\n  subject<span class=\"token punctuation\">:</span> <span class=\"token string\">'Your first KeystoneJS email'</span><span class=\"token punctuation\">,</span>\n<span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span> <span class=\"token keyword\">function</span> <span class=\"token punctuation\">(</span>err<span class=\"token punctuation\">,</span> result<span class=\"token punctuation\">)</span> <span class=\"token punctuation\">{</span>\n  <span class=\"token keyword\">if</span> <span class=\"token punctuation\">(</span>err<span class=\"token punctuation\">)</span> <span class=\"token punctuation\">{</span>\n    console<span class=\"token punctuation\">.</span><span class=\"token function\">error</span><span class=\"token punctuation\">(</span><span class=\"token string\">'🤕 Mailgun test failed with error:\\n'</span><span class=\"token punctuation\">,</span> err<span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n  <span class=\"token punctuation\">}</span> <span class=\"token keyword\">else</span> <span class=\"token punctuation\">{</span>\n    console<span class=\"token punctuation\">.</span><span class=\"token function\">log</span><span class=\"token punctuation\">(</span><span class=\"token string\">'📬 Successfully sent Mailgun test with result:\\n'</span><span class=\"token punctuation\">,</span> result<span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span>\n  <span class=\"token punctuation\">}</span>\n<span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span></code></pre>\n<p>Now run this file with <code>node test-email.js</code>, and you should see this\nlogged in your console:</p>\n<pre><code class=\"language-javascript\">📬 Successfully sent Mailgun test <span class=\"token keyword\">with</span> result\n <span class=\"token punctuation\">{</span> id<span class=\"token punctuation\">:</span> <span class=\"token string\">'&lt;somelongid@sandboxsomestuffhere.mailgun.org>'</span><span class=\"token punctuation\">,</span>\n  message<span class=\"token punctuation\">:</span> <span class=\"token string\">'Queued. Thank you.'</span></code></pre>\n<p>Go check your inbox! Congratulations, you just sent your first email\nwith <code>keystone-email</code>!</p>\n<h2 id=\"inserting-locals\"><a href=\"#inserting-locals\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Inserting locals</h2>\n<p>In a real world scenario you will almost always want to pass data into\nyour templates, for example to say hi to your users by name. Let’s do\nexactly that!</p>\n<p>First, adapt your template to accept data. In Pug you use locals\nwith the <code>#{ recipient.variable }</code> syntax. Change <code>test-email.pug</code> to have this\ncontent:</p>\n<pre><code class=\"language-jade\"><span class=\"token markup\"><span class=\"token comment\" spellcheck=\"true\">&lt;!-- test-email.pug --></span></span>\n\n<span class=\"token doctype\">doctype html</span>\n<span class=\"token tag\">html<span class=\"token attributes\"><span class=\"token punctuation\">(</span><span class=\"token attr-name\">lang</span><span class=\"token punctuation\">=</span><span class=\"token attr-value\"><span class=\"token string\">\"en\"</span></span><span class=\"token punctuation\">)</span></span></span>\n  <span class=\"token tag\">head</span>\n  <span class=\"token tag\">body</span>\n    <span class=\"token tag\">h1</span> <span class=\"token plain-text\">Hi %recipient.firstName% this is your second email sent with Keystone!</span>\n    <span class=\"token tag\">p</span> <span class=\"token plain-text\">This is your full name: %recipient.firstName% %recipient.name%</span></code></pre>\n<p>As you can see above, we need to pass <code>firstName</code> and <code>name</code> to our\ntemplate via the locals option. Go back to <code>test-email.js</code> and take a\nlook at the <code>Email(...).send()</code> call we do:</p>\n<pre><code class=\"language-javascript\"><span class=\"token keyword\">new</span> <span class=\"token class-name\">Email</span><span class=\"token punctuation\">(</span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">.</span><span class=\"token function\">send</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span><span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span> <span class=\"token punctuation\">{</span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span> <span class=\"token keyword\">function</span> <span class=\"token punctuation\">(</span>err<span class=\"token punctuation\">,</span> result<span class=\"token punctuation\">)</span> <span class=\"token punctuation\">{</span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span></code></pre>\n<p>See that empty first argument? Specify your first name and your last\nname in there like so:</p>\n<pre><code class=\"language-javascript\"><span class=\"token keyword\">new</span> <span class=\"token class-name\">Email</span><span class=\"token punctuation\">(</span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">.</span><span class=\"token function\">send</span><span class=\"token punctuation\">(</span><span class=\"token punctuation\">{</span>\n  firstName<span class=\"token punctuation\">:</span> <span class=\"token string\">'Max'</span><span class=\"token punctuation\">,</span>\n  name<span class=\"token punctuation\">:</span> <span class=\"token string\">'Stoiber'</span><span class=\"token punctuation\">,</span>\n<span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span> <span class=\"token punctuation\">{</span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\">}</span><span class=\"token punctuation\">,</span> <span class=\"token keyword\">function</span> <span class=\"token punctuation\">(</span>err<span class=\"token punctuation\">,</span> result<span class=\"token punctuation\">)</span> <span class=\"token punctuation\">{</span><span class=\"token comment\" spellcheck=\"true\">/* ... */</span><span class=\"token punctuation\">}</span><span class=\"token punctuation\">)</span><span class=\"token punctuation\">;</span></code></pre>\n<p>Now send another email with <code>node test-email.js</code>! This is the text you\nshould see once you’ve received it:</p>\n<pre><code class=\"language-sh\">Hi Max, this is your second email sent with Keystone!\n\nLet's hope that this is your first and last name: Max Stoiber\n</code></pre>\n<p>(replacing <code>Max</code> and <code>Stoiber</code> with your first and last names\nrespectively)</p>\n<p>Amazing, that wasn’t too hard, huh? We’ve successfully sent a\npersonalized email!</p>\n<p>Now go ahead and add emails to your app!</p>"
		}
	},
	"pathContext": {
		"slug": "/guides/how-to-send-emails"
	}
};


//////////////////
// WEBPACK FOOTER
// ./.intermediate-representation/json/guides-how-to-send-emails.json
// module id = ./.intermediate-representation/json/guides-how-to-send-emails.json
// module chunks = 16